import { HTMLAttributes, memo } from 'react';
import { isNumber } from '@cutwise/utils';

import { MediaSubFile } from '@/media/entity/MediaSubFile';
import { getFrameUrl } from '@/media/helpers/getFrameUrl';

interface FSetImageProps extends HTMLAttributes<HTMLImageElement> {
  mediaSubFile: MediaSubFile;
  previewFrame?: Nullable<number>;
}

function FSetImage(props: FSetImageProps) {
  const { mediaSubFile, previewFrame, ...rest } = props;

  return (
    <img
      draggable="false"
      src={getFrameUrl(mediaSubFile, isNumber(previewFrame) ? previewFrame : mediaSubFile.firstFrame)}
      alt=""
      {...rest}
    />
  );
}

export default memo(FSetImage);
